export function isOdooHelpdeskRouteEnabled() {
  return process.env.VUE_APP_ODOO_HELPDESK_ENABLED !== 'false'
}
